import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Rx from 'rxjs';
import { AppSettingService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';

export interface INormalizedFileMetaData {
	Name: string,
	LastModifiedReadable: string,
	FileTypeIconImgSrc: string
}

@Injectable({
	providedIn: 'root'
})
export class FileManagementApiService {
	constructor(
		private httpClient: HttpClient,
		private userInfoService: UserInfoService
	) { }
	
	private url = AppSettingService.appConfig.JourneyAPIUrl + "FileManagement";

	uploadFile(inputFileEventFileObj: any, folderId: string = "top", forResourceCopyOccupationName: string = ""): Rx.Observable<any> {
		let formData: FormData = new FormData();
		let currentTime = new Date();
		formData.append('File', inputFileEventFileObj);
		formData.append('FolderId', folderId);
		formData.append('UploadedDate', currentTime.toString());

		let fileName = inputFileEventFileObj.name;
		formData.append('FileName', fileName);

		//for demo purposes: when forResourceCopyOccupationName has length greater than 0, API will save this file to user's Resources folder
		formData.append('ForResourceCopyOccupationName', forResourceCopyOccupationName);
		
		return this.httpClient.post<any>(
			this.url + "/File",			
			formData,
			{
				withCredentials: true,
				headers: {
					'Accept': 'application/json',
					'Authorization': this.userInfoService.authHeader(false)
				}
			}
		);
	}

	downloadFile(fileId: string): Rx.Observable<Blob> {
		return this.httpClient.get<Blob>(
			this.url + "/File/" + encodeURIComponent(fileId),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfoService.authHeader(false) },
				responseType: 'blob' as 'json'
				//observe: 'response'
			}
		);
	}

	createFolder(folderName: string, parentFolderId: string) {
		let currentTime = new Date();

		let payload = {
			FolderName: folderName,
			ParentFolderId: parentFolderId,
			UploadedDate: currentTime.toString()
		};

		return this.httpClient.post<any>(
			this.url + "/Folder",
			payload,
			{
				withCredentials: true,
				headers: {
					//'Content-Type': 'multipart/form-data',
					'Accept': 'application/json',
					'Authorization': this.userInfoService.authHeader(false)
				}
			}
		);
	}

	// folderId should be 'top' to get top level contents
	getFolderContent(folderId: string = 'top'): Rx.Observable<any> {
		return this.httpClient.get<any>(
			this.url + "/Folder/" + encodeURIComponent(folderId),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfoService.authHeader(false) }				
			}
		); 
	}

	deleteFile(fileId: string): Rx.Observable<any> {
		return this.httpClient.delete<any>(
			this.url + "/File/" + encodeURIComponent(fileId),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfoService.authHeader(false) }
			}
		)
	}

	deleteFolder(folderId: string): Rx.Observable<any> {
		return this.httpClient.delete<any>(
			this.url + "/Folder/" + encodeURIComponent(folderId),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfoService.authHeader(false) }
			}
		)
	}

	renameFolder(folderId: string, newFolderName: string): Rx.Observable<any> {
		return this.httpClient.patch<any>(
			this.url + "/Folder/" + encodeURIComponent(folderId) + "/NewFolderName/" + encodeURIComponent(newFolderName),
			null,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfoService.authHeader(false) }
			}
		)
	}
	renameFile(fileId: string, newFileName: string): Rx.Observable<any> {
		return this.httpClient.patch<any>(
			this.url + "/File/" + encodeURIComponent(fileId) + "/NewFileName/" + encodeURIComponent(newFileName),
			null,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfoService.authHeader(false) }
			}
		)
	}
	/*
	getNormalizedFileMetaDataForResume(resumeResponseItem: any): INormalizedFileMetaData {
		const date = new Date(resumeResponseItem.LastModified);

		return {
			Name: resumeResponseItem.Filename,
			LastModifiedReadable: this.getFormattedDateFromTimeStamp(resumeResponseItem.LastModified),
			FileTypeIconImgSrc: this.getFileTypeIconImgSrc(resumeResponseItem.Name)
		}
	}
	*/	
}
